import { useState, useEffect, useRef } from "react";

/**
 * Conta de 0 até `target` em `duration` ms.
 * Só dispara quando `active` for true (default true).
 */
const useCountUp = (target, duration = 900, active = true) => {
  const [value, setValue] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!active || target === 0) { setValue(0); return; }

    let startTime = null;
    const from = 0;
    const to   = target;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed  = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // easeOutCubic — começa rápido, desacelera no final
      const eased    = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(from + (to - from) * eased));
      if (progress < 1) rafRef.current = requestAnimationFrame(step);
    };

    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [target, duration, active]);

  return value;
};

export default useCountUp;